import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { CreateTaxeParafiscalePage } from "@/features/ventes/components/tarifs/CreateTaxeParafiscalePage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/taxes/create")({
  loader: requirePermission(TARIF_PERMISSIONS.TAXES_CREATE),
  staticData: {
    title: "Nouvelle taxe parafiscale",
    showInBreadcrumb: true,
  },
  component: CreateTaxeParafiscalePage,
});
